import React from 'react';
import LinkedRecordOverviewDrawer from 'components/LinkedRecordOverviewDrawer';
import { OperationType } from 'components/RecordsListView/constants';
import { RecordSourceType } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { useAuth } from 'utilities/base-auth';
import { getLinkedRecordDescriptor } from '../../typeDescriptors';
import { LinkedRecordRow } from '../../types';
import DrawerFooter from './components/DrawerFooter';
import useLinkedRecordDetails from './hooks/useLinkedRecordDetails';
import useDrawerPdfDownload from './hooks/useDrawerPdfDownload';

const HEADER_ICON_SIZE_PX = 16;

interface RecommendationLinkedRecordDrawerProps {
  open: boolean;
  record: LinkedRecordRow | null;
  onClose: () => void;
  /** The recommendation being viewed — the origin the banner returns to. */
  recommendationId: string;
}

const RecommendationLinkedRecordDrawer = ({
  open,
  record,
  onClose,
  recommendationId
}: RecommendationLinkedRecordDrawerProps) => {
  const {
    details,
    products,
    propertiesData,
    tankInformation,
    isLoading,
    hasError
  } = useLinkedRecordDetails(open ? record : null);

  const detailsTabType =
    record?.type === RecordSourceType.WORK_ORDER
      ? OperationType.WORK_ORDER
      : OperationType.APPLICATION;

  const {
    user: { id: userId }
  } = useAuth();

  const { downloadPdf, isDownloading } = useDrawerPdfDownload({
    operation: details,
    operationType: detailsTabType,
    userId,
    isOpen: open,
    hasFailed: hasError
  });

  const descriptor = record
    ? getLinkedRecordDescriptor(record.type)
    : undefined;
  const Icon = descriptor?.Icon;

  return (
    <LinkedRecordOverviewDrawer
      open={open}
      onClose={onClose}
      icon={
        Icon ? (
          <Icon width={HEADER_ICON_SIZE_PX} height={HEADER_ICON_SIZE_PX} />
        ) : null
      }
      typeLabel={descriptor?.label ?? ''}
      title={record?.name ?? ''}
      cropSeasonIds={details?.cropSeasonIds ?? record?.cropSeasonIds}
      type={detailsTabType}
      details={details}
      products={products}
      propertiesData={propertiesData}
      tankInformation={tankInformation}
      isLoading={isLoading}
      hasError={hasError}
      footer={
        record ? (
          <DrawerFooter
            record={record}
            recommendationId={recommendationId}
            recordCropSeasonIds={details?.cropSeasonIds ?? record.cropSeasonIds}
            onClose={onClose}
            onDownloadPdf={downloadPdf}
            isDownloadingPdf={isDownloading}
          />
        ) : null
      }
    />
  );
};

export default RecommendationLinkedRecordDrawer;
